(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionarioDeleteController',SSFuncionarioDeleteController);

    SSFuncionarioDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSFuncionario'];

    function SSFuncionarioDeleteController($uibModalInstance, entity, SSFuncionario) {
        var vm = this;

        vm.sSFuncionario = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSFuncionario.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
